import axios from "axios";

import store from "../store";
import { logout } from "../store/actions/auth";
import { LOGIN_BASEURL } from "../config";

const API = axios.create({
  baseURL: LOGIN_BASEURL,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("azureToken") || ""}`,
  },
});

API.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    if (err.response.status !== 401) {
      throw err;
    }
    if (typeof err.response.data.error.name !== "undefined") {
      if (err.response.data.error.name === "TokenExpiredError") {
        store.dispatch(logout());
        throw err;
      }
    }
  }
);

export default API;
